export default __webpack_public_path__ + "static/media/README.116509d3.md";